(function () {

    const setAB = (cohort) =>{
        const winterBanner = document.getElementById("winter-10-banner")
        if(!winterBanner) return;
        if (cohort == "a"){
            if(!winterBanner.classList.contains("winter-hidden")){

                winterBanner.style.display="block";
            }
        }else{
            winterBanner.style.display="none";
            const prodPageWinterBanner = document.querySelector(".product-winter-sale-banner")
            if(prodPageWinterBanner){
              prodPageWinterBanner.display = "block";
            }
        }
        const triggerBanner = document.createElement("div")
        triggerBanner.dataset.dataCroFeatureLoaded = "winter-sale-banner"
        document.body.append(triggerBanner);
    }

  const cohortCheck = setInterval(() => {
    const cohortACheck = document.getElementById("winter-banner-version-a")
    const cohortBCheck = document.getElementById("winter-sale-banner-version-b")
    if(cohortACheck){
        clearInterval(cohortCheck)
        setAB("a")
    }
    if(cohortBCheck){
      clearInterval(cohortCheck)
        setAB("b")
    }
  }, 50);
  setTimeout(()=>{
    clearInterval(cohortCheck);
  },10000)
})();